import { useEffect, useState } from 'react';
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from '@mui/material';

/** Reject a document — always with a reason, which the student and their
 * counselor are sent. Shared by the Documents tab and the Final
 * Documentation Checklist. */
export const RejectDocumentDialog = ({
  target,
  pending,
  error,
  onCancel,
  onConfirm,
}: {
  target: { id: number; label: string } | null;
  pending: boolean;
  error?: string | null;
  onCancel: () => void;
  onConfirm: (reason: string) => void;
}) => {
  const [reason, setReason] = useState('');
  useEffect(() => setReason(''), [target?.id]);
  return (
    <Dialog open={!!target} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle>Reject Document</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <Typography variant="body2" color="text.secondary">
            {target?.label}
          </Typography>
          {error && <Alert severity="error">{error}</Alert>}
          <TextField
            label="Reason for rejection"
            required
            autoFocus
            fullWidth
            multiline
            minRows={3}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            helperText="The student and their counselor are sent this reason."
            inputProps={{ maxLength: 500 }}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancel</Button>
        <Button
          variant="contained"
          color="error"
          disabled={!reason.trim() || pending}
          onClick={() => onConfirm(reason.trim())}
        >
          Reject Document
        </Button>
      </DialogActions>
    </Dialog>
  );
};
